import React, { useState, useRef, useEffect } from "react";
import "../../css/dashboard/DashboardHeader.css";
import logo from "../../assets/mark.svg";
import { Link } from "react-router";
import { logout, useAuth } from "../../context/AuthContext";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

const DashboardHeader = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const { user, logout } = useAuth();

  // get token
  const getToken = () => {
    const name = "token=";
    const decodedCookie = decodeURIComponent(document.cookie);
    // console.log("Full cookie string:", decodedCookie); // Debug line
    const cookieArray = decodedCookie.split(";");
    // console.log("Cookie array:", cookieArray); // Debug line

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      // console.log(`Checking cookie: "${cookie}"`); // Debug line
      // console.log(`Starts with "${name}"?`, cookie.indexOf(name) === 0); // Debug line
      if (cookie.indexOf(name) === 0) {
        const value = cookie.substring(name.length, cookie.length);
        // console.log("Found value:", value); // Debug line
        return value;
      }
    }
    return null;
  };

  const clearAllCookies = () => {
    console.log("Before clearing:", document.cookie);
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      // Try with root path
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      // Also try with no path specified
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
      // If you have specific paths in your app
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/synclinkshare;`;
    });
    console.log("After clearing:", document.cookie);
  };

  // Client-side code to call server
  const handleSignOut = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.get(`${API_URL}/synclinkshare/user/me`, {
        headers: {
          "Content-Type": "multipart/form-data",
          // token: getToken(),
        },
        withCredentials: true,
      });

      // Call server logout endpoint
      await fetch(`${API_URL}/auth/logout`, {
        method: "POST",
        withCredentials: true,
        headers: {
          token: getToken(),
        },
      });

      // Still try to clear cookies client-side as a backup
      clearAllCookies();

      window.location.href = "/";
    } catch (error) {
      console.error("Error signing out:", error);
      // Still redirect even if there was an error
      window.location.href = "/";
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        !event.target.classList.contains("dashboard-mobile-menu-button")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef, mobileMenuRef]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="dashboard-header">
      <div className="dashboard-header-container">
        <div className="dashboard-header-left">
          <div className="dashboard-logo">
            <Link to="/dashboard">
              <img src={logo} alt="SynclinkShare" />
            </Link>
          </div>
        </div>

        {/* Center Mobile Menu Button */}
        <div className="dashboard-mobile-menu-container">
          <button
            className="dashboard-mobile-menu-button"
            onClick={toggleMobileMenu}
          >
            <span className="dashboard-mobile-menu-icon"></span>
          </button>
        </div>

        {/* Navigation */}
        <nav
          className={`dashboard-nav ${isMobileMenuOpen ? "open" : ""}`}
          ref={mobileMenuRef}
        >
          <ul>
            <Link to="/dashboard" className="dashboard-nav-item">
              Dashboard
            </Link>
          </ul>
        </nav>

        <div className="dashboard-header-right">
          <div className="dashboard-notifications"></div>

          <div className="dashboard-profile-container" ref={dropdownRef}>
            <button
              className="dashboard-profile-button"
              onClick={toggleDropdown}
            >
              <img
                src="https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?t=st=1744202013~exp=1744205613~hmac=575e3030df93b1f8ca4d9021410ab4ebbdf0c933b7946e8639ac100a40ee38eb&w=1380"
                alt="Profile"
                className="dashboard-profile-image"
              />
            </button>

            {isDropdownOpen && (
              <div className="dashboard-profile-dropdown">
                <ul>
                  <li>
                    <a href="#" onClick={handleSignOut}>
                      Sign Out
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
